import { render, staticRenderFns } from "./TableAndHeader.vue?vue&type=template&id=8e596340&scoped=true&"
import script from "./TableAndHeader.vue?vue&type=script&lang=js&"
export * from "./TableAndHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableAndHeader.vue?vue&type=style&index=0&id=8e596340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e596340",
  null
  
)

export default component.exports